module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  _.forEach(items, function(item) { 
    ; __append("\r\n    <li>\r\n        ")
    ;  if (item.factoryKey === 'control_play_form_button' ) { 
    ; __append("\r\n            <div id=\"")
    ; __append(escapeFn(item.factoryKey))
    ; __append("\" class=\"common-list-item disable-select pf-icon-list-special\">\r\n                           <span class=\"fa-stack pf-icon-special-small\">\r\n                                <i class=\"fa pf-show-form-button-path1 fa-stack-1x pf-stack-icon-special\"></i>\r\n                                <i class=\"fa pf-show-form-button-path2 fa-stack-1x pf-stack-icon-special\"></i>\r\n                                <i class=\"fa pf-show-form-button-path3 fa-stack-1x pf-stack-icon-special\"></i>\r\n                                <i class=\"fa pf-show-form-button-path4 fa-stack-1x pf-stack-icon-special\"></i>\r\n                                <i class=\"fa pf-show-form-button-path5 fa-stack-1x pf-stack-icon-special\"></i>\r\n                                <i class=\"fa pf-show-form-button-path6 fa-stack-1x pf-stack-icon-special\"></i>\r\n                                <i class=\"fa pf-show-form-button-path7 fa-stack-1x pf-stack-icon-special\"></i>\r\n                                <i class=\"fa pf-show-form-button-path8 fa-stack-1x pf-stack-icon-special\"></i>\r\n                                <i class=\"fa pf-show-form-button-path9 fa-stack-1x pf-stack-icon-special\"></i>\r\n                                <i class=\"fa pf-show-form-button-path10 fa-stack-1x pf-stack-icon-special\"></i>\r\n                                <i class=\"fa pf-show-form-button-path11 fa-stack-1x pf-stack-icon-special\"></i>\r\n                                <i class=\"fa pf-show-form-button-path12 fa-stack-1x pf-stack-icon-special\"></i>\r\n                                <i class=\"fa pf-show-form-button-path13 fa-stack-1x pf-stack-icon-special\"></i>\r\n                                <i class=\"fa pf-show-form-button-path14 fa-stack-1x pf-stack-icon-special\"></i>\r\n                            </span>\r\n                ")
    ; __append(escapeFn(item.name))
    ; __append("\r\n            </div>\r\n        ")
    ;  } else { 
    ; __append("\r\n            <div id=\"")
    ; __append(escapeFn(item.factoryKey))
    ; __append("\" class=\"common-list-item disable-select pf-icon-list-special\">\r\n                <i class=\"fa ")
    ; __append(escapeFn( item.icon ))
    ; __append(" mr-2\"></i>\r\n                ")
    ; __append(escapeFn(item.name))
    ; __append("\r\n            </div>\r\n        ")
    ;  } 
    ; __append("\r\n    </li>\r\n")
    ;  }); 
  }
  return __output;

}